module.exports = __webpack_public_path__ + "static/media/desuno.7ef05d1c.jpg";